import { registerSettingComponent, registerWidget } from "dmeditor";
import definition from "./definition";
import { ClubInfo, onServerSideLoad } from "./ClubInfo";

const register = () => {
  registerWidget(definition, {
    render: ClubInfo,
    onServerSideLoad: onServerSideLoad,
  });
};

export default register;
